import React from 'react';
import { Card } from '@cimpress/react-components';
import { Trans, useTranslation } from 'react-i18next';
import { history } from '../../../utils/history';
import { css, cx } from 'emotion';
import sumBy from 'lodash/sumBy';
import PropTypes from 'prop-types';

const onClickCreateContract = () => {
  history.push('create');
};

const onClickBrowseContracts = () => {
  history.push('contracts');
};

const cardBody = css({
  '& > .card-block': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  }
});

const buttonGroup = css({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  alignSelf: 'end'
});

const browseButton = css({
  padding: '9px 12px'
});

function CreateContractsCard({ terms }) {
  const { t } = useTranslation();

  // Count each occurrence where the initiator is a buyer or a seller
  const numberOfBuyers = sumBy(terms, ({ buyer, initiator }) => Number(buyer.id === initiator.id));
  const numberOfSellers = sumBy(terms, ({ seller, initiator }) => Number(seller.id === initiator.id));

  return (
    <Card header={t('landingPage:createContractsCard:header')} isMinimal className={cardBody}>
      <div className="card-text">{t('landingPage:createContractsCard:cardBody')}</div>
      <div>
        <Trans i18nKey="landingPage:createContractsCard:numberOfBuyerAndSellers">
          <b>{{ numberOfBuyers }}</b> buyer contracts, <b>{{ numberOfSellers }}</b> seller contracts
        </Trans>
      </div>
      <div className={buttonGroup}>
        <button className="btn btn-primary" onClick={onClickCreateContract}>
          {t('common:actions.createNewContract')}
        </button>
        <button className={cx('btn btn-link', browseButton)} onClick={onClickBrowseContracts}>
          {t('landingPage:createContractsCard:browseAll')}
        </button>
      </div>
    </Card>
  );
}

CreateContractsCard.propTypes = {
  terms: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default CreateContractsCard;
